import { useState, useEffect } from 'react';
import { Files } from 'helpers/FileHelpers';
import { MediaList } from 'models/BaseModel';


export const useSignatureImage = (fileList: any, setFileList: React.Dispatch<React.SetStateAction<any>>, setSignatureUrl: React.Dispatch<React.SetStateAction<string | null>>, setError: (error: string | null) => void) => {
  const [signatureImage, setSignatureImage] = useState<File | null>(null);

   useEffect(() => {
    if (fileList?.signature) {
      Files.ImageAPI.Load('signature', fileList, Files.ImageAPI.Fetch, setSignatureUrl);
    }
  }, [fileList, setSignatureUrl]);

  const handleSignatureImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSignatureImage(event.target.files[0]);
    }
  };

  const handleAttachSignatureImage = async () => {
    if (signatureImage) {
      //const uploadedFile = await Files.ImageAPI.Attach(signatureImage, 200, setError);
      const uploadedFile = await Files.ImageAPI.Attach(signatureImage, 200, setError);
      setFileList((prevFileList: MediaList) => ({
        ...prevFileList,
        signature: uploadedFile,
      }));
    }
  };

  const handleDeleteSignatureImage = () => {
    //Files.ImageAPI.Delete(fileList?.signature, setFileList, setSignatureUrl);
    Files.ImageAPI.Delete(fileList?.signature, setFileList, setSignatureUrl);
  };

  return {
    signatureImage,
    handleSignatureImageChange,
    handleAttachSignatureImage,
    handleDeleteSignatureImage,
  };
};
